import React from "react";
import { Typography } from "@mui/material";
import Dialog from "../../library/Dialog";

export { DialogFooter as SubscriptionActionFooter } from "../../library/Dialog";

export default function SubscriptionActionDialog({
  title,
  description,
  icon,
  subscription,
  open,
  onClose,
  loading,
  error,
  maxWidth = "sm",
  contentSx,
  children,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      icon={icon}
      subtitle={
        <>
          {subscription.organization?.name || subscription.owner?.name || subscription.planName}
          {subscription.owner?.email ? ` / ${subscription.owner.email}` : ""}
        </>
      }
      loading={loading}
      maxWidth={maxWidth}
      contentSx={contentSx}
      disabled={Boolean(error)}
      cancelText='Close'
      hideConfirmButton
    >
      {error && (
        <Typography role='status' variant='body2' color='warning.main' sx={{ mb: 2 }}>
          Refresh the subscription before making another change.
        </Typography>
      )}
      {children}
    </Dialog>
  );
}
